import { z } from 'zod';

export const userHardSoftSkillsOptionsSchema = z.object({
    canEditSkills: z.boolean(),
    canReadSkills: z.boolean(),
});

export type UserHardSoftSkillsOptions = z.infer<typeof userHardSoftSkillsOptionsSchema>;
